import moment from 'moment'

export const enclosed = {
  id: '',
  name: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}